import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentRequestIndex } from '../../features/dashboard/DocumentRequestSlice';
import Loading from '../../Loading';
import Header from './Header';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import * as moment from 'jalali-moment';

function DocumentRequestIndex () {

    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const { documents, loading } = useSelector(state => state.documentRequest)

    useEffect(() => {
        dispatch(documentRequestIndex(token))
    },[])

    return (
        <>
        { loading ? ( <Loading /> ) : ''}
        <div className='row g-2 p-5 my-5'>
            <Header title={'مدیریت درخواست سند'} />
            <table className="table table-hover" style={{direction: 'rtl'}}>
                <thead className="table-light">
                    <tr>
                    <th scope="col" className='text-center'>#</th>
                    <th scope="col">نام</th>
                    <th scope="col">نام خانوادگی</th>
                    <th scope="col" className='text-center'>شماره شناسه ملی</th>
                    <th scope="col" className='text-center'>نوع شماره</th>
                    <th scope="col" className='text-center'>شماره</th>
                    <th scope="col" className='text-center'>وضعیت</th>
                    <th scope="col" className='text-center'>تاریخ ایجاد</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {
                        documents.map((document,key) => (
                            <tr>
                                <th className='text-center'>{++key}</th>
                                <td>{document.name}</td>
                                <td>{document.family}</td>
                                <td className='text-center'>{document.nationalId}</td>
                                <td className='text-center'>{(document.numberType == 1) ? 'شماره پلاک' : 'شماره شاسی'}</td>
                                <td className='text-center'>{document.number}</td>
                                <td className='text-center'>
                                    {(document.status == 1) ? '-' : '-'}
                                </td>
                                <td className='text-center'>
                                    {moment(document.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <div className='col-12 text-center'>
                <button className='btn btn-outline-dark px-0'>نمایش بیشتر</button>
            </div>
        </div>
        </>
    )
}

export default DocumentRequestIndex;